import { useContext } from 'react';

import { SearchContext, SearchPageType } from '@zoopla/listing-search-context';

export const useSearchType = (): SearchPageType => {
    const {
        state: { searchType }
    } = useContext(SearchContext);

    return searchType;
};
